module.exports = __webpack_public_path__ + "img/25.e96bf25b.png";